let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("15tjc")).then(() => parcelRequire('cXUQZ'));